import MainMenu from "./components/MainMenu";
import BackgroundImage from "../../components/ui/BackgroundImage";
import menuBg from "./assets/images/menu-bg.webp";
import MainMenuProvider from "./providers/MainMenuProvider";

export const MainMenuWrapper = () => {
  return (
    <MainMenuProvider>
      <BackgroundImage imageSrc={menuBg}>
        <div className="h-screen mid:p-[4.3rem] p-[5rem] pb-14">
          <MainMenu className="w-full h-full max-w-[1500px] 2560px:max-w-[1800px] 3440px:max-w-[2360px] mx-auto" />
        </div>
      </BackgroundImage>
    </MainMenuProvider>
  );
};

export default MainMenuWrapper;
